module.exports = __webpack_public_path__ + "img/piattaformarosso.cda5bdb2.png";